// import dahabiya from "assets/img/payment/EDAHABIA.png";
// import cib from "assets/img/payment/cib.png";
// import backimg from "assets/img/payment/ttten.svg";
import paymentImage from "assets/img/payment/payement.jpg";
import airlinesImage from "assets/img/affiche-je-voyage-ic.jpg";
import { Image } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const PaymentMethods = () => {
    const location = useLocation();
    const [tab, setTab] = useState("flight");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setTab(params.get("tab") || "flight");
    }, [location.search]);

    return (
        <div>
            {tab !== "hotel" && (
                <div className="w-full max-w-[1440px] mx-auto px-3 mt-10 lg:px-0 relative">
                    <Image
                        src={airlinesImage}
                        className="w-full h-auto rounded-lg"
                        alt="airlines"
                    />
                </div>
            )}
            <div className="w-full max-w-[1440px] mx-auto px-3 mt-20 lg:px-0 relative">
                <Image
                    src={paymentImage}
                    className="w-auto h-[400px] rounded-lg mx-auto"
                    alt="payment"
                />
            </div>
        </div>
    );
};

export default PaymentMethods;
